<template>
  <el-dialog
    :title="userinfo"
    :visible.sync="subscriberCardModalVisible"
    :close-on-click-modal="false"
    @open="subscriberCardModalShow"
    @close="subscriberCardModalHide"
    fullscreen
  >
    <div
      class="more-info__inner subscriber-card-container"
      ref="subscriberCard"
    >
      <el-row type="flex" justify="space-between" style="margin-right: 1em">
        <el-col :span="24">
          <div
            v-if="visibleCard"
            class="subscriber-card"
            v-append="subscriberCard"
          ></div>
        </el-col>
      </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-row type="flex" justify="space-between">
        <el-col :span="24" style="text-align:right;">
          <el-button
            type="plain"
            size="small"
            @click="subscriberCardModalVisible = false"
            ><span class="key-name">Esc</span
            >{{ $t("common.buttons.close") }}</el-button
          >
        </el-col>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { dialogWidth } from "@/mixins/dialogWidth";

export default {
  name: "subscribercard",
  props: ["abcode", "userinfo"],
  mixins: [dialogWidth],
  data() {
    return {
      subscriberCardModalVisible: false,
      visibleCard: false
    };
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapGetters(["subscriberCardModal", "subscriberCard"])
  },
  watch: {
    subscriberCardModal: function(value) {
      this.subscriberCardModalVisible = value;
    },
    subscriberCardModalVisible: function(value) {
      this.setSubscriberCardModal(value);
    },
    subscriberCard: function(value) {
      this.visibleCard = value ? true : false;
    }
  },
  methods: {
    ...mapMutations(["setSubscriberCardModal", "clearSubscriberCard"]),
    ...mapActions(["getSubscriberCard"]),
    subscriberCardModalShow() {
      const abcode = this.abcode;
      this.getSubscriberCard({ abcode });
    },
    subscriberCardModalHide() {
      this.$refs.subscriberCard.scrollTo(0, 0);
      this.visibleCard = false;
      this.clearSubscriberCard();
    }
  }
};
</script>

<style lang="scss" scoped>
.subscriber-card {
  color: #000000;
}

.subscriber-card-container {
  height: calc(100vh - 150px);
}
</style>
<style lang="scss">
.el-dialog__body {
  padding: 15px 20px;
}
</style>
